import React from 'react';

import styles from './SoftCard.module.scss';

const Header = ({children}) => {
    return(
        <div className={styles["header-text"]}>
            {children}
        </div>
    )
}
Header.displayName='SoftCard.Header'

const Footer = ({children}) => {
    return(
        <div className={styles["footer-text"]}>
            {children}
        </div>
    )
}
Footer.displayName='SoftCard.Footer'

/**
 * 
 * @param {function} onClick - function to call when the card is clicked
 * @param {boolean} border - if true, will add a border around the card, default to divider color 
 * @param {string} width - default to "250px"
 * @param {children} - Header, Footer, regular content (can use SoftCard.Header and SoftCard.Footer)
 * @param {boolean} hover - if true, will add a hover effect to the card
 * @param {string} variant - bold (darker lines), primary(color from theme)
 * @returns 
 */
export const SoftCard = ({
    onClick,
    border=true,
    width="250px",
    maxWidth="unset",
    children,
    hover=false,
    variant="soft",
}) =>{

    const header = React.Children.toArray(children).find(child => child.type?.displayName === 'SoftCard.Header')
    const footer = React.Children.toArray(children).find(child => child.type?.displayName === 'SoftCard.Footer')
    const body = React.Children.toArray(children).filter(child => child.type?.displayName !== 'SoftCard.Header' && child.type?.displayName !== 'SoftCard.Footer')

    return(
        <div 
            className={`
                ${styles["soft-card-wrapper"]}
                ${styles[variant]}
                ${onClick ? styles["clickable"] : ""}
                ${border ? styles["border"] : ""}
                ${hover ? styles["hover"] : ""}
            `}
            style={{minWidth: width, maxWidth: maxWidth}}
            onClick={onClick}
        >
            {header}
            <div className={styles["main-content"]}>
                {body}
            </div>
            {footer}
        </div>
    )
}

SoftCard.Header = Header;
SoftCard.Footer = Footer;
